"use strict";

(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.agendaDate = {
    attach: function attach(context, settings) {
      var handler = this; // Initialisation des boutons

      once('buttonStatus', '.daterange', context).forEach(function (el) {
        handler.setButtonStatus();
      }); // Boutons non actifs

      once('agendaDate', '.daterange button:not(.active)', context).forEach(function (el) {
        $(el).on('click', function (e) {
          e.preventDefault();
          var arg = $(this).data('range');
          var $dateStartInput = $('.form-item-field-n-date-interval-end-value-1-date input');
          var $dateEndInput = $('.form-item-field-n-date-interval-value-date input');

          switch (arg) {
            case 'today':
              var today_string = handler.getTodayDate();
              $dateStartInput.val(today_string);
              $dateEndInput.val(today_string);
              break;

            case 'tomorrow':
              var tomorrow_string = handler.getTomorrowDate();
              $dateStartInput.val(tomorrow_string);
              $dateEndInput.val(tomorrow_string);
              break;

            case 'weekend':
              var from_string = handler.getNextFriday();
              var to_string = handler.getNextSunday();
              $dateStartInput.val(from_string);
              $dateEndInput.val(to_string);
              break;
          }

          $(this).parents('form').find('.form-submit').click();
        });
      }); // Boutons actifs

      once('agendaDateOff', '.daterange button.active', context).forEach(function (el) {
        $(el).on('click', function (e) {
          $('.form-item-field-n-date-interval-end-value-1-date input').val('');
          $('.form-item-field-n-date-interval-value-date input').val('');
          $(this).parents('form').find('.form-submit').click();
        });
      });
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) {
        month = '0' + month;
      }

      if (day.length < 2) {
        day = '0' + day;
      }

      return [year, month, day].join('-');
    },
    jumpToNextDay: function jumpToNextDay(date, day) {
      return new Date(+date + (7 - (date.getDay() + (7 - day)) % 7) * 86400000);
    },
    getTodayDate: function getTodayDate() {
      var today = new Date();
      return this.formatDate(today);
    },
    getTomorrowDate: function getTomorrowDate() {
      var today = new Date();
      var tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
      return this.formatDate(tomorrow);
    },
    getNextFriday: function getNextFriday() {
      var today = new Date();
      var current_day = today.getDay();

      if (current_day > 4) {
        today.setDate(today.getDate() - 4);
      }

      var friday = this.jumpToNextDay(today, 5);
      return this.formatDate(friday);
    },
    getNextSunday: function getNextSunday() {
      var today = new Date();
      var current_day = today.getDay();

      if (current_day > 4) {
        today.setDate(today.getDate() - 4);
      }

      var sunday = this.jumpToNextDay(today, 7);
      return this.formatDate(sunday);
    },
    setButtonStatus: function setButtonStatus() {
      var todayDate = this.getTodayDate();
      var tomorrowDate = this.getTomorrowDate();
      var fridayDate = this.getNextFriday();
      var sundayDate = this.getNextSunday();
      var $dateStartValue = $('.form-item-field-n-date-interval-end-value-1-date input').val();
      var $dateEndValue = $('.form-item-field-n-date-interval-value-date input').val();

      if ($dateStartValue === todayDate && $dateEndValue === todayDate) {
        $('.daterange button[data-range="today"]').addClass('active').on('click', function (e) {
          e.preventDefault();
        });
      }

      if ($dateStartValue === tomorrowDate && $dateEndValue === tomorrowDate) {
        $('.daterange button[data-range="tomorrow"]').addClass('active').on('click', function (e) {
          e.preventDefault();
        });
      }

      if ($dateStartValue === fridayDate && $dateEndValue === sundayDate) {
        $('.daterange button[data-range="weekend"]').addClass('active').on('click', function (e) {
          e.preventDefault();
        });
      }
    }
  };
})(jQuery, Drupal, once);